import { EvidenceId } from "../tools/schemas/evidence";

/**
 * The agent cites a record as a markdown link whose href is its evidence id behind `cite:` and
 * whose title names the record: `[1](cite:statement:<id> "Balance sheet, FYE Dec 31, 2025")`. A
 * document read adds its first page, `[1](cite:file:<id>?page=8 "Name.pdf, p. 8")`. The link text
 * is a placeholder number.
 */
export const CITATION_SCHEME = "cite:";

const EVIDENCE_KIND = EvidenceId.kinds.join("|");
const UUID = "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
const EVIDENCE_ID = `(?:${EVIDENCE_KIND}):${UUID}`;
const PAGE = "(?:\\?page=\\d+)?";
const LIST_SEPARATOR = "\\s*[,;]\\s*(?:and\\s+)?|\\s+and\\s+";

/** A citation link's href, capturing its evidence kind, id, and page. */
export const CITATION_HREF = new RegExp(
	`^${CITATION_SCHEME}(${EVIDENCE_KIND}):(${UUID})(?:\\?page=(\\d+))?$`,
	"i",
);

/** One evidence id written as text, `cite:` optional. Build it with the `gi` flags. */
export const EVIDENCE_TOKEN_PATTERN = `(?:${CITATION_SCHEME})?${EVIDENCE_ID}${PAGE}`;

/**
 * Evidence ids the model wrote as text instead of links: a bracketed list (separated by commas,
 * semicolons, or "and") that isn't a link's text, or a lone `cite:` id in a sentence. Build it
 * with the `gi` flags.
 */
export const TEXT_CITATION_PATTERN = `\\[\\s*${EVIDENCE_TOKEN_PATTERN}(?:(?:${LIST_SEPARATOR})${EVIDENCE_TOKEN_PATTERN})*\\s*\\](?!\\()|(?<![\\w-])${CITATION_SCHEME}${EVIDENCE_ID}${PAGE}`;
